import PageHero from "@/components/site/PageHero";
import { useSEO } from "@/lib/seo";
import { useSiteSettings } from "@/lib/settings";
import { renderRichParagraphs } from "@/lib/cms-defaults";

const FALLBACK = `**1. Introduction.** PharmacoHires ("we", "us") values the privacy of candidates, clients and visitors. This policy explains what we collect, how we use it, and your rights.

**2. Data we collect.** When you apply for a role or submit a form, we collect your name, contact details, professional history, resume file, and any details you choose to share. We may also collect basic analytics data such as IP address and browser type.

**3. Why we collect it.** To evaluate your candidacy for relevant openings, to match you with clients, to respond to enquiries, and to improve our services. We do not sell your data.

**4. Sharing.** Your resume and profile may be shared with prospective employers in connection with a specific opening, after our internal screening. We will not share your data with any third party without a legitimate purpose.

**5. Storage and retention.** Resumes and application data are stored securely on our servers. We retain data for as long as relevant to keep you considered for future openings; you may request deletion at any time.

**6. Your rights.** You can request a copy of your data, ask for corrections, or request deletion by emailing <a href="mailto:careers@pharmacohires.com">careers@pharmacohires.com</a>.

**7. Cookies.** We use minimal first-party cookies for session and basic analytics. We do not run third-party advertising trackers.

**8. Updates.** We may update this policy from time to time. The latest version will always be available on this page.`;

export default function Privacy() {
  useSEO({ title: "Privacy Policy", description: "How PharmacoHires handles your personal data.", pageKey: "privacy" });
  const { settings } = useSiteSettings();
  const raw = (settings?.privacy_content || "").trim() || FALLBACK;
  return (
    <>
      <PageHero overline="Legal" title="Privacy Policy" />
      <section className="section-pad">
        <div className="container-page prose-pharma max-w-3xl" data-testid="privacy-content">
          {renderRichParagraphs(raw)}
        </div>
      </section>
    </>
  );
}
